import React, { useMemo } from "react";
import Barcode from "react-barcode";

const Sheet = React.forwardRef(function Sheet(
  { product, formattedPrice, qty, options },
  ref
) {
  const {
    labelW,
    labelH,
    gap,
    margin,
    nameSize,
    priceSize,
    showBorder,
    uppercase,
    boldName,
    boldPrice,
    showSKU,
    sku,
  } = options;

  const styleVars = {
    ["--label-w"]: `${labelW}mm`,
    ["--label-h"]: `${labelH}mm`,
    ["--gap"]: `${gap}mm`,
    ["--margin"]: `${margin}mm`,
    ["--name-size"]: `${nameSize}px`,
    ["--price-size"]: `${priceSize}px`,
  };

  // If options.allLabels is provided, use it for rendering
  const labels = useMemo(() => {
    if (options.allLabels && Array.isArray(options.allLabels)) {
      return options.allLabels;
    }
    return Array.from({ length: Math.max(0, Number(qty) || 0) }).map(() => ({
      Product: product,
      Price: formattedPrice,
      Currency: options.currency || "",
      SKU: options.sku || "",
    }));
  }, [product, formattedPrice, qty, options]);

  return (
    <div
      ref={ref}
      className="mx-auto bg-white"
      style={{ width: "210mm", height: "297mm", padding: "var(--margin)", ...styleVars }}
    >
      <div
        className="w-full h-full grid"
        style={{
          gridTemplateColumns: `repeat(auto-fill, minmax(var(--label-w), 1fr))`,
          gridAutoRows: `var(--label-h)`,
          gap: `var(--gap)`,
        }}
      >
        {labels.map((p, i) => (
          <div
            key={i}
            className={`flex flex-row items-center justify-between rounded-xl ${
              showBorder ? "border" : ""
            }`}
            style={{ padding: "4mm", textAlign: "left" }}
          >
            {/* Logo + Zmart */}
            <div className="flex items-center gap-2">
              <img
                src="/Zmart.jpg"
                alt="Zmart Logo"
                className="h-8 w-8 object-contain"
              />
              <span className="text-sm font-bold">Zmart</span>
            </div>
            {/* Product + Price */}
            <div className="flex flex-col items-end">
              <div
                className={`${boldName ? "font-extrabold" : "font-medium"}`}
                style={{
                  fontSize: "var(--name-size)",
                  lineHeight: 1.1,
                  textTransform: uppercase ? "uppercase" : "none",
                }}
              >
                {p.Product || p.Name || product}
              </div>
              <div
                className={`${boldPrice ? "font-black" : "font-bold"} tracking-tight`}
                style={{ fontSize: "var(--price-size)", lineHeight: 1.0 }}
              >
                {typeof p.Price === "number"
                  ? `${p.Currency || "EGP"} ${Number(p.Price).toFixed(2)}`
                  : formattedPrice}
              </div>
              {showSKU && (
                <div className="flex flex-col items-end mt-1">
                  <div className="text-[10px] text-neutral-600">{p.SKU || options.sku || ""}</div>
                  <Barcode
                    value={p.SKU || options.sku || ""}
                    width={1.5}
                    height={40}
                    fontSize={12}
                    margin={0}
                    displayValue={false}
                  />
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}); 

export default Sheet;
